import { render } from "./ModalsNFTBox.vue?vue&type=template&id=8c09b918"
import script from "./ModalsNFTBox.vue?vue&type=script&lang=js"
export * from "./ModalsNFTBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__